










import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Progress extends Vue {
  @Prop({ default: "small" }) private size!: 'small' | 'large';
  @Prop({ required: true })
  private tomato!: { tomato: number; tomatoed: number };
}

